import { createApp } from "vue"
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/tailwind.css";
import "./assets/css/loadingIndicator.css";
import "./assets/css/leaflet.css";
import "./assets/css/fontFace.css";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library, dom } from "@fortawesome/fontawesome-svg-core";

//free-solid-svg-icons
import { faNewspaper } from "@fortawesome/free-solid-svg-icons/faNewspaper";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";

//free-brands-svg-icons
import { faExternalLink } from "@fortawesome/pro-regular-svg-icons/faExternalLink";

//pro-duotone-svg-icons
import { faInfoCircle } from "@fortawesome/pro-duotone-svg-icons/faInfoCircle";


library.add(
  faNewspaper,
  faTimesCircle,
  faInfoCircle,
  faExternalLink,
);

const app = createApp({
  extends: App,
  beforeCreate() {

  },
  created() {

  },
})




// app.use(fullscreen);
app.component("font-awesome-icon", FontAwesomeIcon)
app.use(store);
app.use(router);

app.mount("#app")


